import { LanguageType } from "../../types";
import toLanguageType from "./toLanguageType";

export default function getLanguageFromUrl(): LanguageType | null {
  const searchParams = new URLSearchParams(window.location.search);
  const lang = searchParams.get("lang")?.trim();

  if (!lang) return null;

  return toLanguageType(lang);
}
